import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ImportCsvButton } from "./ImportCsvButton";
import { ImportJsonButton } from "./ImportJsonButton";
import type { EditorWord } from "./types";

export interface EditorHeaderProps {
  title: string;
  word: EditorWord | undefined;
  onClickCreateWord: () => void;
  saveDisabled: boolean;
  onClickSave: () => void;
  onExportCsv: () => void;
  exportJsonUrl: string;
  onImported: (words: Record<string, string>) => void;
  onImportError: (error: Error) => void;
  onPartiallyImported: (words: Record<string, string>) => void;
  onClose: () => void;
}

export function EditorHeader({
  title,
  word,
  onClickCreateWord,
  saveDisabled,
  onClickSave,
  onExportCsv,
  exportJsonUrl,
  onImported,
  onImportError,
  onPartiallyImported,
  onClose,
}: EditorHeaderProps) {
  return (
    <AppBar elevation={0} color="default" position="sticky">
      <Toolbar>
        <IconButton
          edge="start"
          sx={{ mr: 1.25 }}
          onClick={onClose}
          size="large"
        >
          <ArrowBackIcon />
        </IconButton>

        <Typography variant="h6" color="inherit" sx={{ marginRight: "auto" }}>
          {title}
        </Typography>

        <ImportCsvButton onImported={onImported} onError={onImportError} />

        <Button onClick={onExportCsv} color="inherit">
          Export CSV
        </Button>

        <ImportJsonButton
          onImported={onPartiallyImported}
          onError={onImportError}
        />

        <Button target="_blank" href={exportJsonUrl} color="inherit">
          Export JSON
        </Button>

        {word && (
          <Button onClick={onClickCreateWord} color="inherit">
            Создать ключ
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          sx={{ ml: 1 }}
          disabled={saveDisabled}
          onClick={onClickSave}
        >
          Save
        </Button>
      </Toolbar>
    </AppBar>
  );
}
